import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useDocumentTitle } from '../../../_hooks/useDocumentTitle';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import BoardRoomSVG from '../../../CommonComponents/OPL/illustrations/board-room.svg';
import { Wrapper, StyledCard } from '../WorkflowWelcome/WorkflowWelcome.styles';
import { OnboardingWorkflow } from '../../../CommonSelectors/CommonArea.types';
import { WorkflowIdEnum } from '../../api/useWorkflowDataQuery';

export const WorkflowDone = () => {
  useDocumentTitle('Completed Workflow');

  return (
    <Wrapper as="main">
      <StyledCard as="article">
        <BoardRoomSVG width={280} style={{ margin: '0 auto' }} />

        <Text as="h1" fontWeight={600} fontSize="h4" mt="24" mb="8">
          Thank you for completing the plan.
        </Text>

        <Text as="p" color="neutral.500" fontWeight={500}>
          Your financial plan is being prepared. Your advisor will contact you when they are ready
          to review your personalized plan with you.
        </Text>

        <Button
          onClick={() =>
            ADV.util.Router.go2('Workflow', {
              clientId: ADV.data.user.Id,
              workflowId:
                ADV.data.user.ConsumerAccessWorkflow === OnboardingWorkflow.AssetBucketingWorkflow
                  ? WorkflowIdEnum.AssetBucketing
                  : WorkflowIdEnum.Comprehensive,
              stepId: 0,
              pivotId: 0,
              pageId: 'start',
            })
          }
          mt="32"
        >
          Keep Editing
        </Button>
      </StyledCard>
    </Wrapper>
  );
};
